import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Switch, Redirect, Route } from 'react-router-dom'
import Home from './Home/Home'
import NotFound from './NotFound/NotFound'
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'
import { ModalWrapper, Modal } from '@gluedigital/modal'
import Login from './Account/Login/Login'
import Recover from './Account/Recover/Recover'
import RecoverComplete from './Account/Recover/RecoverComplete'
import Asset from './Asset/Asset'
import Loading from 'src/components/Loading/Loading'
import Profile from './Profile/Profile'
import Meta from 'src/components/Meta/Meta'
import Associate from './Account/Associate/Associate'
import firebase from 'src/util/firebase'

const App = () => {
  const isLoggedIn: boolean = useSelector((s: any) => !!s?.user?.token)
  const isReady: boolean = useSelector((s: any) => s.ready)

  const dispatch = useDispatch()

  useEffect(() => {
    // Special action so we know that we just finished rendering
    dispatch({ type: '@@_AFTER_RENDER' })
  }, [dispatch])

  useEffect(() => {
    firebase.foregroundMessage()
  }, [])

  if (!isReady) return <Loading /> // Prevents accidental navigation

  return (
    <ModalWrapper>
      <main id="app">
        <ErrorBoundary>
          <Meta />
          <Switch>
            <Route path="/" exact>
              { isLoggedIn ? <Home /> : <Redirect to="/login" /> }
            </Route>
            <Route path="/assets/:assetId" exact>
              { isLoggedIn ? <Asset /> : <Redirect to="/login" /> }
            </Route>
            <Route path="/profile" exact>
              { isLoggedIn ? <Profile /> : <Redirect to="/login" /> }
            </Route>
            <Route path="/login" exact>
              { !isLoggedIn ? <Login /> : <Redirect to="/" /> }
            </Route>
            <Route path="/recover" exact>
              <Recover />
            </Route>
            <Route path="/recover/:user/:token" exact>
              <RecoverComplete />
            </Route>
            <Route path="/mfa/associate/:id/:secret">
              <Associate />
            </Route>
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </ErrorBoundary>
        <Modal />
      </main>
    </ModalWrapper>
  )
}

export default App
